<div class="sidebar" [class]="{ 'expanded': true }">
    <div class="header">
        <h1 class="title">
            Mariage Admin
        </h1>
    </div>
    <div class="content">
        <div class="link">
            <div class="content" (click)="navTo('dashboard')" [class]="'dashboard' | adminActiveRoute : currentRoute()">
                <div class="title"><i class="bi bi-graph-up"></i>Dashboard</div>
            </div>
        </div>
        <div class="link">
            <div class="content" (click)="navTo('import')" [class]="'import' | adminActiveRoute : currentRoute()">
                <div class="title"><i class="bi bi-file-earmark-arrow-up-fill"></i>Importer</div>
            </div>
        </div>
        <div class="link">
            <div class="content" (click)="navTo('display')" [class]="'display' | adminActiveRoute : currentRoute()">
                <div class="title"><i class="bi bi-table"></i>Tableau</div>
            </div>
        </div>
        <div class="link">
            <div class="content" (click)="navTo('edit-faq')" [class]="'edit-faq' | adminActiveRoute : currentRoute()">
                <div class="title"><i class="bi bi-journal-text"></i>Modifier FAQ</div>
            </div>
        </div>
        <div class="link">
            <div class="content" (click)="navTo('notifs')" [class]="'notifs' | adminActiveRoute : currentRoute()">
                <div class="title"><i class="bi bi-bell"></i>Notifications</div>
            </div>
        </div>
    </div>
</div>